import { render, staticRenderFns } from "./unload-content-wrapper.vue?vue&type=template&id=05e8d902"
import script from "./unload-content-wrapper.vue?vue&type=script&lang=js"
export * from "./unload-content-wrapper.vue?vue&type=script&lang=js"
import style0 from "./unload-content-wrapper.vue?vue&type=style&index=0&id=05e8d902&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports